import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import ContactCTA from "../components/ContactCTA";
import WhyChooseUs from "../components/WhyChooseUs";
import PartnersSection from "../components/PartnersSection";
import CustomersSection from "../components/CustomersSection";

export default function About() {
  const { t } = useTranslation();

  return (
    <>
      <div className="pt-20 bg-white">
        {/* Header */}
        <section className="bg-gradient-to-br from-[#e9f2fc] to-[#d0e7f9] py-20 px-6 md:px-16 sm:px-4">
          <div className="max-w-4xl mx-auto text-center">
            <span className="inline-block bg-textBlue text-white text-md px-6 py-2 rounded-full mb-4">
              {t("about.label")}
            </span>
            <h1 className="text-5xl md:text-4xl sm:text-3xl font-bold text-gray-800 mb-6">
              {t("about.title")}
            </h1>
          </div>
        </section>

        {/* About Content */}
        <section className="py-16 px-6 md:px-16 sm:px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-1 gap-12 mb-16">
              {/* Description */}
              <div className="space-y-6">
                <p className="text-lg text-gray-600 leading-relaxed">
                  {t("about.description")}
                </p>
                <p className="text-lg text-gray-600 leading-relaxed">
                  {t("about.description2")}
                </p>
              </div>

              {/* Mission & Vision */}
              <div className="space-y-6">
                <div className="bg-blueLight p-6 rounded-lg">
                  <h3 className="text-2xl font-semibold text-textBlue mb-3">
                    {t("about.vision")}
                  </h3>
                  <p className="text-gray-700">{t("about.visionText")}</p>
                </div>
                <div className="bg-backgroundTeal p-6 rounded-lg">
                  <h3 className="text-2xl font-semibold text-textBlue mb-3">
                    {t("about.mission")}
                  </h3>
                  <p className="text-gray-700">{t("about.missionText")}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <WhyChooseUs />
        <PartnersSection />
        <CustomersSection />
        <ContactCTA />
        <Footer />
      </div>
    </>
  );
}
